import { GeneralRequest } from 'structured-requests';
import { generateRequestForClient } from 'request-generator';
import { openCCModal } from '../../../../packages/client-web-app/subscription';
import flagMessageForPCINoncompliance from './ccModal/creditCardRegex.js';

export default class ComposeViewCtrl {
  constructor(
    $location,
    $scope,
    benchLocation,
    blConstants,
    ClientSettings,
    User,
    DashboardClient,
    NotificationsService,
    featureFlagService,
    Client,
    Person,
  ) {
    this.clientId = User.getClientId();
    this.dashboardClient = new DashboardClient(this.clientId);
    this.NotificationsService = NotificationsService;
    this.User = User;
    this.blConstants = blConstants;
    this.composeViewExpanded = false;

    const client = new Client(this.clientId);
    this.principalPerson = new Person(client.principalPerson.id);

    this.$scope = $scope;
    this.settings = new ClientSettings(this.clientId);
    this.isInBkTools =
      benchLocation.apiRoot().includes($location.$$host) || $location.$$host.includes('bktools');

    this.periodKeyCode = 190;
    this.slashKeyCode = 191;
    this.showPreview = false;
    this.showMessagePreview = false;
    this.supportedServiceBubbles = {
      GeneralRequest,
    };

    this.featureFlagService = featureFlagService;
    this.sms = null;
  }

  formatText(format) {
    if (!this.showMessageFormatting()) {
      return;
    }

    const textarea = this.getTextArea();

    if (!textarea) {
      console.error('No textarea found for formatting');
      return;
    }

    textarea.focus();

    setTimeout(() => {
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const selectedText = this.message.substring(start, end);

      this.applyFormatting(format, textarea, start, end, selectedText);
    }, 0);
  }

  getTextArea() {
    let textarea;
    if (this.composeViewExpanded) {
      textarea = document.querySelector('.compose-view_textarea-lg');
    } else {
      textarea = document.querySelector('.compose-view_textarea-sm');
    }
    return textarea;
  }

  applyFormatting(format, textarea, start, end, selectedText) {
    let markupStart = '';
    let markupEnd = '';
    let placeholderText = 'text';
    let cursorOffset = 0;

    switch (format) {
      case 'bold':
        markupStart = '**';
        markupEnd = '**';
        placeholderText = 'bold text';
        cursorOffset = 2;
        break;
      case 'italic':
        markupStart = '__';
        markupEnd = '__';
        placeholderText = 'italic text';
        cursorOffset = 2;
        break;
      case 'underline':
        markupStart = '~~';
        markupEnd = '~~';
        placeholderText = 'underlined text';
        cursorOffset = 2;
        break;
      default:
        return;
    }

    // Get the actual textarea value which preserves trailing spaces
    const textareaValue = textarea.value;

    if (start === end) {
      const updatedMessage =
        textareaValue.substring(0, start) +
        markupStart +
        placeholderText +
        markupEnd +
        textareaValue.substring(end);

      this.message = updatedMessage;

      if (!this.$scope.$$phase) {
        this.$scope.$apply();
      }

      setTimeout(() => {
        textarea.setSelectionRange(
          start + cursorOffset,
          start + cursorOffset + placeholderText.length,
        );
        textarea.focus();
      }, 0);
    } else {
      const updatedMessage =
        textareaValue.substring(0, start) +
        markupStart +
        selectedText +
        markupEnd +
        textareaValue.substring(end);

      this.message = updatedMessage;

      if (!this.$scope.$$phase) {
        this.$scope.$apply();
      }

      setTimeout(() => {
        textarea.setSelectionRange(end + cursorOffset * 2, end + cursorOffset * 2);
        textarea.focus();
      }, 0);
    }
  }

  formatBoldText() {
    this.formatText('bold');
  }

  formatItalicText() {
    this.formatText('italic');
  }

  formatUnderlineText() {
    this.formatText('underline');
  }

  formatOrderedList() {
    this.formatList('ordered');
  }

  formatUnorderedList() {
    this.formatList('unordered');
  }

  formatLink() {
    if (!this.showMessageFormatting()) {
      return;
    }

    const textarea = this.getTextArea();

    if (!textarea) {
      console.error('No textarea found for formatting');
      return;
    }

    textarea.focus();

    setTimeout(() => {
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      // Get the actual textarea value which preserves trailing spaces
      const textareaValue = textarea.value;
      const selectedText = textareaValue.substring(start, end);

      let newText;
      let linkTextStart;
      let linkTextEnd;

      if (start === end) {
        newText =
          textareaValue.substring(0, start) +
          '[text](https://bench.co)' +
          textareaValue.substring(end);

        // Set selection to highlight the text placeholder
        linkTextStart = start + 1;
        linkTextEnd = start + 5;
      } else {
        // Text is selected, determine if it's a URL or text
        const isUrl = /^(https?:\/\/|www\.)\S+$/i.test(selectedText);

        if (isUrl) {
          // Selected text is a URL, use it as the link URL and add a placeholder for link text
          newText =
            textareaValue.substring(0, start) +
            '[text](' +
            selectedText +
            ')' +
            textareaValue.substring(end);

          linkTextStart = start + 1;
          linkTextEnd = start + 5;
        } else {
          newText =
            textareaValue.substring(0, start) +
            '[' +
            selectedText +
            '](https://bench.co)' +
            textareaValue.substring(end);

          // Set selection to highlight the URL placeholder
          linkTextStart = start + selectedText.length + 3;
          linkTextEnd = start + selectedText.length + 19;
        }
      }

      this.message = newText;

      if (!this.$scope.$$phase) {
        this.$scope.$apply();
      }

      setTimeout(() => {
        textarea.setSelectionRange(linkTextStart, linkTextEnd);
        textarea.focus();
      }, 0);
    }, 0);
  }

  previewMessage() {
    if (!this.showMessageFormatting()) {
      return;
    }

    if (!this.showMessagePreview) {
      this.messageComponentProps = {
        message: this.message,
      };

      // Position textarea offscreen first
      const textarea = this.composeViewExpanded
        ? document.querySelector('.compose-view_textarea-lg')
        : document.querySelector('.compose-view_textarea-sm');

      if (textarea) {
        // Move textarea offscreen immediately before showing preview
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        textarea.style.height = '1px';
      }

      // Now enable preview
      this.showMessagePreview = true;

      if (!this.$scope.$$phase) {
        this.$scope.$apply();
      }
    } else {
      const textarea = this.composeViewExpanded
        ? document.querySelector('.compose-view_textarea-lg')
        : document.querySelector('.compose-view_textarea-sm');

      if (textarea) {
        textarea.style.position = '';
        textarea.style.left = '';
        textarea.style.height = '';
      }

      setTimeout(() => {
        this.showMessagePreview = false;

        setTimeout(() => {
          if (textarea) {
            textarea.focus();
          }
        }, 0);

        if (!this.$scope.$$phase) {
          this.$scope.$apply();
        }
      }, 5);
    }
  }

  formatList(listType) {
    if (!this.showMessageFormatting()) {
      return;
    }

    const textarea = this.getTextArea();

    if (!textarea) {
      console.error('No textarea found for formatting');
      return;
    }

    textarea.focus();

    setTimeout(() => {
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      // Get the actual textarea value which preserves trailing spaces
      const textareaValue = textarea.value;
      const selectedText = textareaValue.substring(start, end);

      const listMarker = listType === 'ordered' ? '1. ' : '- ';

      let newText;
      let newCursorPos;

      if (start === end) {
        // No selection, insert a new list item on a new line
        const beforeCursor = textareaValue.substring(0, start);
        const afterCursor = textareaValue.substring(end);

        // Ensure we have a newline before the list if we're not at the start of the message
        // and the previous character isn't already a newline
        const needsNewlineBefore =
          start > 0 && beforeCursor.charAt(beforeCursor.length - 1) !== '\n';
        const prefix = needsNewlineBefore ? '\n' : '';

        // Ensure we have a newline after the list item if the cursor isn't at the end and
        // the next character isn't already a newline
        const needsNewlineAfter = end < textareaValue.length && afterCursor.charAt(0) !== '\n';
        const suffix = needsNewlineAfter ? '\n' : '';

        newText = beforeCursor + prefix + listMarker + 'List item' + suffix + afterCursor;
        newCursorPos = start + prefix.length + listMarker.length + 'List item'.length;
      } else {
        // Text is selected, make each line a list item
        const lines = selectedText.split('\n');

        // Format each line, with incrementing numbers for ordered lists
        const formattedLines = lines.map((line, index) => {
          if (line.trim().length === 0) {
            return line; // Keep empty lines as-is
          }

          // For ordered lists, increment the number for each line
          if (listType === 'ordered') {
            return `${index + 1}. ${line}`;
          } else {
            return `${listMarker}${line}`;
          }
        });

        const formattedText = formattedLines.join('\n');

        newText = textareaValue.substring(0, start) + formattedText + textareaValue.substring(end);
        newCursorPos = start + formattedText.length;
      }

      this.message = newText;

      if (!this.$scope.$$phase) {
        this.$scope.$apply();
      }

      // Set the cursor position
      setTimeout(() => {
        if (start === end) {
          // If no selection, select the "List item" text
          const needsNewlineBefore =
            start > 0 &&
            this.message.substring(0, start).charAt(this.message.substring(0, start).length - 1) !==
              '\n';
          const listItemStart = start + (needsNewlineBefore ? 1 : 0) + listMarker.length;
          textarea.setSelectionRange(listItemStart, listItemStart + 'List item'.length);
        } else {
          // If text was selected, place cursor at the end of the formatted text
          textarea.setSelectionRange(newCursorPos, newCursorPos);
        }
        textarea.focus();
      }, 0);
    }, 0);
  }

  $onInit() {
    this.$scope.$on('blKeydown', (onEvent, keypressEvent) => {
      // Check if command/ control + . was pressed
      if (
        keypressEvent.keyCode === this.periodKeyCode &&
        (keypressEvent.metaKey || keypressEvent.ctrlKey)
      ) {
        this.toggleOrSetComposeMode();
        this.$scope.$apply();
        return;
      }

      if (this.showMessageBuilder()) {
        // Check if command/ control + / was pressed
        if (
          keypressEvent.keyCode === this.slashKeyCode &&
          (keypressEvent.metaKey || keypressEvent.ctrlKey)
        ) {
          this.onToggleRequestsView();
          this.$scope.$apply();
        }
      }
    });

    this.clientInitials = this.clientName
      .split(' ')
      .map(x => x.slice(0, 1))
      .slice(0, 2)
      .join('');
  }

  insertGeneratedRequestText() {
    const insertGeneratedRequest = generateRequestForClient(this.User.getClientId()).then(
      generatedRequestText => {
        const requestMessage = generatedRequestText || 'No data is being requested at this time.';
        // If there is already a message being composed, insert the generated message below it with
        // an empty line in between
        const messagePrefix = this.message ? `${this.message}\n\n` : '';
        this.message = `${messagePrefix}${requestMessage}`;
      },
    );
    this.NotificationsService.loader({
      resolve: insertGeneratedRequest,
      loadingText: 'Generating request...',
      successText: 'Request inserted into message.',
      failureText: 'Failed to generate request.',
    });
  }

  showMessageBuilder() {
    return this.settings.$featureEnabled('messageBuilder') && this.isInBkTools;
  }

  showMessageFormatting() {
    return this.featureFlagService.isMessageFormattingEnabled();
  }

  showSmsOption() {
    return this.isInBkTools && this.featureFlagService.isSmsMessageFeedEnabled();
  }

  toggleSms() {
    this.sms = this.sms ? null : { send: true, immediateSend: true };
    // Apply changes to scope if needed
    if (!this.$scope.$$phase) {
      this.$scope.$apply();
    }
  }

  // returns the reason for SMS not available; or null of SMS is available.
  smsError() {
    if (!!this.sms) {
      if (this.message.length >= 1420) {
        return 'Message is too long for SMS';
      } else if (this.principalPerson.smsOptIn === false) {
        return 'Client has opted out of SMS';
      } else if (!!this.principalPerson.phoneNumberError) {
        return 'Phone number is incorrect or international';
      } else if (!this.principalPerson.phone) {
        return 'Phone number is not defined';
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  toggleOrSetComposeMode(state) {
    if (state !== undefined) {
      this.setComposeMode(state);
    } else {
      this.setComposeMode(!this.composeViewExpanded);
    }
  }

  setComposeMode(state) {
    this.composeViewExpanded = state;
  }

  handleSend() {
    const sendOptions = this.showSmsOption() && this.sms ? { sms: this.sms } : {};

    if (flagMessageForPCINoncompliance(this.message)) {
      openCCModal(() => this.onSend(sendOptions), this.dashboardClient.id);
    } else {
      this.onSend(sendOptions);
      this.toggleOrSetComposeMode(false);
    }
    // Reset SMS checkbox after sending
    this.sms = null;
  }

  handleMessageInputKeydown(e) {
    const key = e.which || e.keyCode;

    if (e.metaKey || e.ctrlKey) {
      switch (key) {
        // CMD/CTRL + B for Bold
        case 66: // B key
          if (this.showMessageFormatting()) {
            this.formatBoldText();
            e.preventDefault();
            return;
          }
          break;

        // CMD/CTRL + I for Italic
        case 73: // I key
          if (this.showMessageFormatting()) {
            this.formatItalicText();
            e.preventDefault();
            return;
          }
          break;

        // CMD/CTRL + U for Underline
        case 85: // U key
          if (this.showMessageFormatting()) {
            this.formatUnderlineText();
            e.preventDefault();
            return;
          }
          break;

        // CMD/CTRL + K for Link
        case 75: // K key
          if (this.showMessageFormatting()) {
            this.formatLink();
            e.preventDefault();
            return;
          }
          break;

        // CMD/CTRL + E for Preview
        case 69: // E key
          if (this.showMessageFormatting()) {
            this.previewMessage();
            e.preventDefault();
            return;
          }
          break;

        // CMD/CTRL + S for SMS toggle
        case 83: // S key
          if (this.showSmsOption()) {
            this.toggleSms();
            e.preventDefault();
            return;
          }
          break;

        // CMD/CTRL + ENTER to send
        case this.blConstants.KEY_CODE.ENTER:
          this.handleSend();
          e.preventDefault();
          return;
      }
    }

    // Handle other special cases for list shortcuts
    if (e.shiftKey && e.metaKey) {
      switch (key) {
        // CMD+SHIFT + 8 for Bullet List (asterisk key)
        case 56: // 8 key (with Shift gives *)
          if (this.showMessageFormatting()) {
            this.formatUnorderedList();
            e.preventDefault();
            return;
          }
          break;

        // CMD+SHIFT + 7 for Numbered List (ampersand key on US keyboards, which gives 7 with shift)
        case 55: // 7 key
          if (this.showMessageFormatting()) {
            this.formatOrderedList();
            e.preventDefault();
            return;
          }
          break;
      }
    }

    // Handle ENTER key for list continuation (only when message formatting is enabled)
    if (
      key === this.blConstants.KEY_CODE.ENTER &&
      !e.ctrlKey &&
      !e.metaKey &&
      this.showMessageFormatting()
    ) {
      // Get the textarea and cursor position
      const textarea = e.target;
      const cursorPos = textarea.selectionStart;

      // Check if we're in a list item by examining the current line
      // Get the actual textarea value which preserves trailing spaces
      const text = textarea.value;
      const beforeCursor = text.substring(0, cursorPos);

      // Find the start of the current line
      const lastNewlineIndex = beforeCursor.lastIndexOf('\n');
      const lineStart = lastNewlineIndex === -1 ? 0 : lastNewlineIndex + 1;

      // Get the current line up to the cursor
      const currentLine = beforeCursor.substring(lineStart);

      // Before checking for list patterns, verify the cursor position is at the end of the line
      // This prevents continuing a list if the user has deleted part of the list marker
      const isAtEndOfLine = cursorPos === beforeCursor.length;

      // Only check for list patterns if we're at the end of the current line
      if (isAtEndOfLine) {
        // Check if the current line matches list patterns
        const orderedListMatch = currentLine.match(/^(\d+)\.\s+(.*)/);
        const unorderedListMatch = currentLine.match(/^[-*]\s+(.*)/);

        // If we're in a list item and Enter was pressed
        if ((orderedListMatch || unorderedListMatch) && !e.shiftKey) {
          // If it's an empty list item, we'll remove it (exit the list)
          if (
            (orderedListMatch && orderedListMatch[2].trim() === '') ||
            (unorderedListMatch && unorderedListMatch[1].trim() === '')
          ) {
            // Remove the empty list item and properly concatenate the text after cursor
            const newText = beforeCursor.substring(0, lineStart) + text.substring(cursorPos);
            this.message = newText;

            // Update cursor position
            setTimeout(() => {
              textarea.setSelectionRange(lineStart, lineStart);
              textarea.focus();
            }, 0);

            if (!this.$scope.$$phase) {
              this.$scope.$apply();
            }
            e.preventDefault();
            return;
          }

          // Otherwise, continue the list with a new item
          let newListItem;

          if (orderedListMatch) {
            // Increment the number for ordered lists
            const currentNumber = parseInt(orderedListMatch[1], 10);
            newListItem = `${currentNumber + 1}. `;
          } else {
            // Keep the same marker for unordered lists
            newListItem = unorderedListMatch[0].substring(0, 2) + ' ';
          }

          // Insert new list item
          const newText = beforeCursor + '\n' + newListItem + text.substring(cursorPos);
          this.message = newText;

          // Position cursor at the start of the new list item's content
          const newCursorPos = cursorPos + 1 + newListItem.length;

          setTimeout(() => {
            textarea.setSelectionRange(newCursorPos, newCursorPos);
            textarea.focus();
          }, 0);

          if (!this.$scope.$$phase) {
            this.$scope.$apply();
          }
          e.preventDefault();
          return;
        }
      }
    }

    // Default Enter behavior for sending
    if (!this.composeModeEnabled) {
      if (key === this.blConstants.KEY_CODE.ENTER && !e.shiftKey) {
        this.handleSend();
        e.preventDefault();
      }
    }
  }
}
